const subregisters = [
  { id:1,  city_id:1,  sub_name:"Chennai North"    },
  { id:2,  city_id:1,  sub_name:"Chennai South"    },
  { id:3,  city_id:2,  sub_name:"Madurai North"    },
  { id:4,  city_id:2,  sub_name:"Madurai South"    },
  { id:5,  city_id:3,  sub_name:"Coimbatore East"  },
  { id:6,  city_id:5,  sub_name:"Bengaluru East"   },
  { id:7,  city_id:5,  sub_name:"Bengaluru West"   },
  { id:8,  city_id:11, sub_name:"Hyderabad Central"},
  { id:9,  city_id:12, sub_name:"Mumbai Suburban"  },
];
export default subregisters;